import { ArrowLeft } from 'lucide-react';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../services/users';
import { notify } from '../../helpers';
import { useDocumentTitle } from '../../hooks/customDocumentTitleHook';
import Spacing from '../Spacing';

export default function ForgotPassword() {
  const now = new Date();
  const currentYear = now.getFullYear();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      notify('error', 'Please enter email address');
      return;
    }

    setLoading(true);

    try {
      const response = await forgotPassword({ email });
      if (response?.message) {
        notify('success', response.message);
        navigate('/login');
      }
    } catch (error) {
      if (error.response?.data?.detail) {
        notify('error', error.response.data.detail);
      } else if (error.response?.data?.message) {
        notify('error', error.response.data.message);
      } else {
        notify('error', 'Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  useDocumentTitle('Forgot Password');

  return (
    <div className="docpro_login_wrap">
      <div
        className="docpro_login_thumb"
        style={{ backgroundImage: 'url(/images/login_img.png)' }}
      ></div>
      <div className="docpro_login_right">
        <div className="docpro_login_card_wrap">
          <form className="docpro_login_card">
            <div className="docpro_text_center">
              <img src="/images/logo_2.svg" alt="Logo" />
              <Spacing lg="32" sm="32" />
              <h1 className="docpro_mb_0">Forgot your password?</h1>
            </div>
            <Spacing lg="20" sm="20" />
            <p className="docpro_mb_0">
              Enter the email address associated with your account and we'll
              send you a link to reset your password.
            </p>
            <Spacing lg="20" sm="20" />
            <label className="docpro_fw_500 docpro_primary_color docpro_fs_16">
              Email <span className="docpro_red_color">*</span>
            </label>
            <input
              type="email"
              className="docpro_form_field size_lg"
              onChange={handleChange}
              disabled={loading}
            />
            <Spacing lg="20" sm="20" />
            <button
              className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn docpro_fs_16"
              onClick={handleEmailSubmit}
              disabled={loading}
            >
              <span>{loading ? 'Sending...' : 'Continue'}</span>
            </button>
            <Spacing lg="20" sm="20" />
            <div className="docpro_text_center docpro_fs_16 docpro_fw_500">
              <Link to="/login" className="docpro_back_btn_2">
                <ArrowLeft /> Back to Sign in
              </Link>
            </div>
          </form>
        </div>
        <footer className="docpro_login_footer">
          <div className="docpro_login_footer_nav">
            <Link to="/">Privacy policy</Link>
            <Link to="/">Terms & conditions</Link>
            <Link to="/">Terms of service</Link>
            <Link to="/">HIPAA Compliance</Link>
          </div>
          <p>© {currentYear} DocPro. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
